import React, { Fragment, useState } from "react";
import ModalDetailsRow from "../../../../components/ModalDetailsRow/ModalDetailsRow.component";
import { Loader } from "../../../../UI/Loaders/Loaders";
import LockUnlockUserForm from "./LockUnlockUserForm.component";
import useGetAdminUser from "../../../../components/ManageRoles/hooks/useGetAdminUser";

export default function ViewUser({ dataRecord, onCloseModal }) {
  const [showLockUnlockForm, setShowLockUnlockForm] = useState(false);

  const printHandler = () => {};
  const { ssoUserId } = dataRecord;

  const { data: userDetail, isLoading: isLoadingUserDetail } =
    useGetAdminUser(ssoUserId);

  const user = userDetail;

  console.log("userDetail: ", userDetail);

  if (showLockUnlockForm) {
    return (
      <LockUnlockUserForm
        user={user}
        onBack={() => setShowLockUnlockForm(false)}
        onSuccess={() => setShowLockUnlockForm(false)}
      />
    );
  }

  return (
    <Fragment>
      <h3 className="Modal__title p-b-2 text-center">User Information</h3>
      {isLoadingUserDetail || !user ? (
        <Loader centered text="Loading user details..." />
      ) : (
        <form>
          <ModalDetailsRow
            label="Email"
            value={user?.email}
            icon="fas fa-user-circle"
          />
          <ModalDetailsRow
            label="First Name"
            value={user?.firstName}
            icon="fas fa-user-circle"
          />
          <ModalDetailsRow
            label="Last Name"
            value={user?.lastName}
            icon="fas fa-user-circle"
          />
          <ModalDetailsRow
            label="User Name"
            value={user?.userName}
            icon="fas fa-user-circle"
          />
          <ModalDetailsRow
            label="User Type"
            value={user?.userType}
            icon="fas fa-user-circle"
          />
          <ModalDetailsRow
            label="Phone Number"
            value={user?.phoneNumber}
            icon="fas fa-user-circle"
          />
          <ModalDetailsRow
            label="Date Joined"
            value={user?.createdDate && user?.createdDate.substring(0, 10)}
            icon="fas fa-user-circle"
          />
          <ModalDetailsRow
            label="Last Login"
            value={
              user?.lastLogin
                ? `${user?.lastLogin.substring(0, 10)} / ${user?.lastLogin.substring(11, 19)}`
                : "N/A"
            }
            icon="fas fa-user-circle"
          />
          <ModalDetailsRow
            label="Locked Status"
            value={user?.isLocked ? "Locked" : "Unlocked"}
            icon="fas fa-lock"
          />

          <div className="Form__action-buttons m-t-1">
            <button
              type="button"
              className="btn zoom-element btn login-btn m-0 mr-auto"
              onClick={printHandler}
            >
              <i className="fas fa-print"></i>
              &nbsp; Print
            </button>
            <button
              type="button"
              className="btn zoom-element btn login-btn m-0"
              onClick={() => setShowLockUnlockForm(true)}
            >
              <i
                className={`fas fa-${user?.isLocked ? "lock-open" : "lock"}`}
              ></i>
              &nbsp; {user?.isLocked ? "Unlock User" : "Lock User"}
            </button>
            <button
              type="button"
              className="btn zoom-element btn login-btn m-0 ml-auto"
              onClick={onCloseModal}
              data-dismiss="modal"
            >
              <i className="fas fa-times-circle"></i>
              &nbsp; Go Back
            </button>
          </div>
        </form>
      )}
    </Fragment>
  );
}
